var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.55,91.19A42,42,0,1,1,397,55.78,41.92,41.92,0,0,1,444.55,91.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.67,92.63a32,32,0,1,1-36.25-27A32,32,0,0,1,434.67,92.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.52,91.64c-.19,0-.53-1.34-1.39-3.69a34.08,34.08,0,0,0-5.06-9.17,32.74,32.74,0,0,0-5-5.14,32.25,32.25,0,0,0-7-4.32,30.37,30.37,0,0,0-4.17-1.55,31.37,31.37,0,0,0-9.32-1.24,31.6,31.6,0,0,0-9.69,1.72,32.1,32.1,0,0,0-4.4,1.91,29.83,29.83,0,0,0-3.92,2.46,28.85,28.85,0,0,0-3.38,2.89,31.52,31.52,0,0,0-8,13,34.05,34.05,0,0,0-1.6,10.35c0,2.51.16,3.91,0,3.94s-.62-1.32-.92-3.88a29.63,29.63,0,0,1,.88-10.89A32.68,32.68,0,0,1,374.33,81a32.21,32.21,0,0,1,5.24-7,30.38,30.38,0,0,1,3.58-3.16,31,31,0,0,1,4.19-2.71,32.5,32.5,0,0,1,4.73-2.1,36.38,36.38,0,0,1,5.15-1.35,35.57,35.57,0,0,1,5.31-.5,31.44,31.44,0,0,1,5.16.34,30.42,30.42,0,0,1,4.86,1.1A29.57,29.57,0,0,1,417,67.27a32.15,32.15,0,0,1,12.46,10.48A29.64,29.64,0,0,1,434,87.67C434.64,90.18,434.66,91.62,434.52,91.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.34,115.59l.88,5.51-4.92.78-.85-5.35c-4.91.48-9.83-.29-12.87-2l1.75-6.43a19.94,19.94,0,0,0,10.09,2l-1.32-8.2c-5.66-.45-12.05-1.3-13.17-8.32-.83-5.21,2.23-10.29,9.85-12.41l-.87-5.46,4.91-.79.86,5.36a22.51,22.51,0,0,1,10.45,1.4l-1.49,6.44a20.38,20.38,0,0,0-7.92-1.36l1.34,8.36c5.65.4,11.94,1.26,13.05,8.19C419.93,108.41,416.9,113.43,409.34,115.59ZM401,94.67l-1.12-7c-2.51,1-3.31,2.6-3.05,4.22S398.67,94.33,401,94.67Zm10.34,10.48c-.27-1.72-1.85-2.42-4.08-2.82l1.09,6.78C410.67,108.18,411.54,106.73,411.29,105.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.69,272s-9.31-5.38-18.94,16.69-13,34.66-13,34.66-2.62,4.66-5.87,1.92-8-10.82-13.13-9c-5.34,1.88-6.76,8.05-5.19,16.89s4.3,28.36,4.54,30.12-.6,4.36-3.12,2.84-17.37-16.17-23.91-8.71,1.89,31.39,2.77,34,.41,3.81-.82,4.55-5.76-4.66-10.15-8.66-10.19-7.86-13.6-3.24-3.49,23,15.68,51.58l9.75,12.68,16-1.85c33.91-6,47.07-18.82,48-24.48s-5.84-7.16-11.76-7.55-13,.09-13.28-1.31.21-2.54,2.71-3.74,25.58-11.72,26.42-21.61-20-10.41-22.86-11.17-1.53-3.19-.12-4.22,17.39-12.62,24.85-17.62,10.92-10.31,8.57-15.46c-2.26-5-11.35-2.77-15.58-3.21s-2.7-5.56-2.7-5.56,6.72-11.18,15.94-33.42-1.38-25.23-1.38-25.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.29,445c6.84-16.31,16.47-38.75,27.19-63.52s20.41-47.17,27.33-63.44L652,298.77l2.23-5.24.59-1.35c.14-.31.22-.46.22-.46a4.09,4.09,0,0,1-.16.48l-.55,1.37c-.49,1.23-1.21,3-2.13,5.28-1.86,4.58-4.6,11.19-8,19.34C637.33,334.5,627.7,357,617,381.7s-20.41,47.19-27.33,63.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.89,327.78a5,5,0,0,1,.48,1.06c.27.69.64,1.7,1.09,3,.88,2.51,2,6,3.17,9.89l3,9.95c.36,1.18.66,2.18.91,3a4.72,4.72,0,0,1,.28,1.12,4.73,4.73,0,0,1-.48-1.05c-.28-.7-.65-1.71-1.08-3-.86-2.52-1.93-6-3.1-9.91l-3-9.92-.92-3A4.09,4.09,0,0,1,618.89,327.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.25,356c0-.14,7.06-2.78,15.87-5.9s16-5.53,16-5.38-7.06,2.78-15.87,5.9S629.3,356.1,629.25,356Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.08,393.23a4.82,4.82,0,0,1,1.17-.13l3.21-.19c2.7-.16,6.44-.4,10.55-.81s7.82-.88,10.5-1.26l3.18-.43a4.76,4.76,0,0,1,1.18-.1,4.45,4.45,0,0,1-1.14.31c-.74.16-1.82.37-3.16.61-2.67.47-6.38,1-10.51,1.42s-7.87.58-10.59.64c-1.36,0-2.45,0-3.21,0A4.44,4.44,0,0,1,611.08,393.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.09,369.82s.28.28.69.85,1,1.39,1.71,2.43c1.41,2.06,3.34,4.94,5.44,8.13s4,6.1,5.32,8.22c.67,1.06,1.2,1.93,1.56,2.53a4.7,4.7,0,0,1,.51,1,4,4,0,0,1-.69-.85c-.41-.57-1-1.4-1.71-2.43-1.41-2.07-3.34-4.94-5.44-8.14s-4-6.1-5.32-8.22c-.67-1.06-1.2-1.92-1.56-2.53A4.82,4.82,0,0,1,596.09,369.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.87,400.69a7.52,7.52,0,0,1,.86,1.09c.58.83,1.32,1.87,2.2,3.11,1.83,2.64,4.33,6.31,7.06,10.37s5.18,7.77,6.93,10.46l2.05,3.21a7.16,7.16,0,0,1,.69,1.22,6.92,6.92,0,0,1-.87-1.1l-2.19-3.11c-1.83-2.64-4.33-6.3-7.07-10.37s-5.18-7.77-6.93-10.46c-.82-1.28-1.5-2.36-2.05-3.21A6,6,0,0,1,575.87,400.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.38,429.31a7.83,7.83,0,0,1,1.49-.21l4-.38c3.42-.33,8.15-.79,13.35-1.45s9.9-1.36,13.3-1.9l4-.63a7.38,7.38,0,0,1,1.49-.16,8.18,8.18,0,0,1-1.45.37c-.94.21-2.3.49-4,.8-3.38.64-8.08,1.41-13.29,2.06s-10,1.07-13.39,1.29c-1.72.11-3.11.19-4.07.22A7.58,7.58,0,0,1,595.38,429.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.4,339.66,117.81,280.34a9.29,9.29,0,0,1-6.11-11.63L148.35,151A9.28,9.28,0,0,1,160,144.87l190.6,59.33a9.28,9.28,0,0,1,6.1,11.62L320,333.56A9.27,9.27,0,0,1,308.4,339.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.93,228.92a15.06,15.06,0,1,1-9.9-18.86A15.05,15.05,0,0,1,318.93,228.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,245.4a16.25,16.25,0,0,1-2.73-.6,15.49,15.49,0,1,1,2.73.6Zm3.73-29.9a14.45,14.45,0,1,0,12,18.63h0a14.46,14.46,0,0,0-9.5-18.09A15.6,15.6,0,0,0,323.68,215.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.58,234.53,139,246.09l-1.19-.37,3.27-10.5-2.72-.85.33-1.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.2,248.74l-.33,1.06-8.11-2.53.27-.84,6.27-3.21c1.7-.89,2.19-1.59,2.44-2.38.42-1.34-.27-2.46-2-3a4.12,4.12,0,0,0-3.56.31l-.62-1a5.44,5.44,0,0,1,4.61-.38c2.35.73,3.47,2.39,2.87,4.32-.35,1.11-1,2-3,3l-5.14,2.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,250.54l-2.32-.71-.94,3-1.19-.38.94-3-6.52-2,.26-.86,8.52-5.75,1.32.41-8.24,5.62,5,1.57.83-2.68,1.15.36-.83,2.68,2.31.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.72,256.06l-2.31-.72-.95,3-1.19-.37.95-3-6.53-2,.27-.86,8.51-5.76,1.32.41-8.23,5.63,5,1.56.83-2.67,1.16.36-.84,2.67,2.32.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.94,258.84c-.61,2-2.46,3.08-5.29,2.2a6.23,6.23,0,0,1-3.68-2.78l.87-.76a5.23,5.23,0,0,0,3.13,2.44c2,.62,3.31,0,3.75-1.42s-.18-2.7-3.12-3.62l-2.46-.76,2.4-5.62,6.33,2-.33,1.06-5.29-1.65-1.54,3.57,1.49.46C191.68,255,192.58,256.8,191.94,258.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.38,262.35c-.67,2.17-2.8,3-5,2.33-3.07-1-4.08-3.61-2.94-7.26,1.22-3.93,4-5.32,7.15-4.34a5.56,5.56,0,0,1,2.54,1.48l-.77.81a4.32,4.32,0,0,0-2.08-1.24c-2.49-.78-4.6.33-5.57,3.47a9.12,9.12,0,0,0-.25.95,3.88,3.88,0,0,1,4.16-.88C202.86,258.39,204,260.24,203.38,262.35ZM202.2,262c.47-1.52-.35-2.84-2.13-3.4s-3.31.17-3.76,1.6c-.4,1.28.29,2.81,2.28,3.43A2.65,2.65,0,0,0,202.2,262Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.17,267.41c-.61,1.93-2.47,3-5.26,2.11a6.28,6.28,0,0,1-3.7-2.78l.87-.76a5.24,5.24,0,0,0,3.17,2.45c1.91.6,3.25,0,3.69-1.4s-.26-2.6-2.4-3.27l-.83-.26.27-.87,4.46-3-5.92-1.84.33-1.06,7.44,2.32-.27.84-4.55,3.1C218.91,263.87,219.74,265.56,219.17,267.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.8,270.89c-.67,2.16-2.8,3-5.05,2.32-3.07-1-4.08-3.61-2.94-7.26,1.22-3.93,4-5.31,7.15-4.33a5.53,5.53,0,0,1,2.54,1.48l-.77.81a4.33,4.33,0,0,0-2.08-1.25c-2.5-.77-4.6.33-5.57,3.47a9.36,9.36,0,0,0-.25,1,3.87,3.87,0,0,1,4.15-.89C230.28,266.92,231.46,268.77,230.8,270.89Zm-1.18-.34c.47-1.51-.35-2.84-2.13-3.39s-3.31.16-3.76,1.6c-.4,1.27.28,2.8,2.28,3.43A2.65,2.65,0,0,0,229.62,270.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,266.09l-.27.84-8.17,9.22-1.29-.41,8-9-5.94-1.85-.68,2.16-1.17-.37,1-3.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5,271.23l-.26.85-8.18,9.21-1.29-.4,8-9-6-1.85-.67,2.17-1.18-.37,1-3.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.28,283.12c-.64,2.05-2.77,2.78-5.53,1.92s-4.06-2.66-3.42-4.71a3,3,0,0,1,3.11-2.15,2.72,2.72,0,0,1-1-3.11c.58-1.88,2.55-2.55,5-1.79s3.71,2.44,3.13,4.32a2.74,2.74,0,0,1-2.65,2A3,3,0,0,1,269.28,283.12Zm-1.21-.4c.44-1.42-.51-2.69-2.56-3.33s-3.53-.12-4,1.3.48,2.71,2.53,3.34S267.62,284.16,268.07,282.72Zm-2.26-4.27c1.8.56,3.12.08,3.51-1.17s-.48-2.45-2.22-3-3.1-.1-3.5,1.19S264,277.89,265.81,278.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.34,284c-1.22,3.93-4,5.31-7.15,4.33a5.48,5.48,0,0,1-2.54-1.48l.77-.81a4.2,4.2,0,0,0,2.08,1.24c2.49.78,4.6-.32,5.57-3.46.09-.27.17-.6.25-1a3.88,3.88,0,0,1-4.16.88c-2.29-.71-3.47-2.57-2.81-4.68s2.8-3,5-2.32C281.47,277.65,282.48,280.3,281.34,284Zm-.92-2.81c.4-1.27-.29-2.81-2.28-3.43a2.66,2.66,0,0,0-3.61,1.63c-.48,1.52.34,2.85,2.13,3.4S280,282.59,280.42,281.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.84,281.92l-3.6,11.57-1.19-.37,3.27-10.51-2.73-.85.33-1.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.46,296.13l-.33,1.06L295,294.66l.26-.84,6.27-3.21c1.71-.88,2.2-1.58,2.45-2.38.41-1.33-.27-2.45-2-3a4.13,4.13,0,0,0-3.56.3l-.61-1a5.44,5.44,0,0,1,4.61-.37c2.34.73,3.46,2.38,2.86,4.31-.35,1.11-1,2-3,3l-5.13,2.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.54,297.1c-.6,1.93-2.47,3-5.27,2.11a6.33,6.33,0,0,1-3.69-2.78l.87-.76a5.32,5.32,0,0,0,3.16,2.45c1.92.6,3.26,0,3.7-1.4s-.26-2.6-2.4-3.27l-.83-.26.27-.87,4.46-3-5.92-1.84.33-1.06,7.44,2.31-.26.85-4.56,3.09C314.28,293.56,315.11,295.25,314.54,297.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.93,
    y: 249.75,
    width: 5.26,
    height: 97.01,
    transform: "translate(-96.73 465.1) rotate(-72.71)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.37,
    y: 290.43,
    width: 5.26,
    height: 49.76,
    transform: "translate(-99.35 495.65) rotate(-72.71)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.23,
    y: 198.69,
    width: 40.71,
    height: 30.41,
    rx: 4.96,
    transform: "translate(70.92 -38.66) rotate(17.29)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.13,214.32l.58-1.86,20,6.23a4.39,4.39,0,1,0,2.61-8.38l-20-6.23.58-1.86,20,6.23a6.34,6.34,0,1,1-3.77,12.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.04,
    y: 211.04,
    width: 1.95,
    height: 14.39,
    transform: "matrix(0.3, -0.95, 0.95, 0.3, -85.47, 320.24)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.99,
    y: 186.22,
    width: 104.69,
    height: 8.98,
    transform: "translate(66.11 -53.31) rotate(17.29)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.73,395.49a26.55,26.55,0,1,1-30.09-22.39A26.52,26.52,0,0,1,190.73,395.49Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.48,396.4a20.24,20.24,0,1,1-22.93-17.07A20.23,20.23,0,0,1,184.48,396.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.38,395.77a11.94,11.94,0,0,1-.88-2.33,21.65,21.65,0,0,0-3.2-5.8,20,20,0,0,0-10.24-7,17.93,17.93,0,0,0-2.86-.61,20.22,20.22,0,0,0-3-.18,23.54,23.54,0,0,0-3.11.3,22.66,22.66,0,0,0-3,.79,19.78,19.78,0,0,0-2.78,1.21,20,20,0,0,0-4.62,3.38,20,20,0,0,0-3.21,4.09,20.84,20.84,0,0,0-1.87,4.15,21.64,21.64,0,0,0-1,6.54,11,11,0,0,1,0,2.5,6.23,6.23,0,0,1-.58-2.46,19.06,19.06,0,0,1,.56-6.89,21.19,21.19,0,0,1,1.8-4.48,20.73,20.73,0,0,1,3.32-4.46,19.08,19.08,0,0,1,2.26-2,20.38,20.38,0,0,1,2.65-1.71,21.17,21.17,0,0,1,3-1.32,23.29,23.29,0,0,1,3.26-.86,22.6,22.6,0,0,1,3.36-.32,20.6,20.6,0,0,1,3.26.22,19.4,19.4,0,0,1,3.08.69,20,20,0,0,1,2.81,1.1,20.32,20.32,0,0,1,7.88,6.63,18.89,18.89,0,0,1,2.9,6.27A5.94,5.94,0,0,1,184.38,395.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.45,410.92l.56,3.48-3.11.5-.54-3.39a14.88,14.88,0,0,1-8.13-1.24l1.1-4.07a12.74,12.74,0,0,0,6.38,1.24l-.83-5.19c-3.59-.28-7.62-.81-8.33-5.26-.53-3.29,1.41-6.5,6.23-7.85l-.55-3.45,3.1-.5.55,3.39a14.25,14.25,0,0,1,6.61.89l-.94,4.07a12.9,12.9,0,0,0-5-.86l.85,5.29c3.58.25,7.55.8,8.25,5.18C175.15,406.38,173.24,409.55,168.45,410.92Zm-5.3-13.23-.71-4.42c-1.59.64-2.1,1.65-1.93,2.67S161.71,397.47,163.15,397.69Zm6.54,6.63c-.17-1.09-1.17-1.53-2.58-1.79l.69,4.29C169.3,406.23,169.85,405.31,169.69,404.32Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.43,406.55c-1.94,2.76-5.71,1.85-7.45.16s-2.49-4.14-3.16-6.48c-1.54-5.33-3.08-10.93-1.94-16.37a9.14,9.14,0,0,1,2.09-4.45,4.77,4.77,0,0,1,4.5-1.5c1.9.5,3.08,2.37,3.93,4.14a39,39,0,0,1,3.86,16.74c0,2.7-.31,5.53-1.83,7.76",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M587.43,406.55c-1.94,2.76-5.71,1.85-7.45.16s-2.49-4.14-3.16-6.48c-1.54-5.33-3.08-10.93-1.94-16.37a9.14,9.14,0,0,1,2.09-4.45,4.77,4.77,0,0,1,4.5-1.5c1.9.5,3.08,2.37,3.93,4.14a39,39,0,0,1,3.86,16.74c0,2.7-.31,5.53-1.83,7.76"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M580.17,420.57a16.8,16.8,0,0,0-10.43-1.27,8.61,8.61,0,0,0-5.14,2.3c-1.29,1.42-1.53,3.92-.06,5.14a4.94,4.94,0,0,0,3.25.82c2.75,0,5.81-.52,8,1.14,1.26.95,2.09,2.52,3.6,3a3.56,3.56,0,0,0,3.9-1.74,6,6,0,0,0,.44-4.48A6.81,6.81,0,0,0,580.17,420.57Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.75,410.52a10.08,10.08,0,0,1-1.56-9.27,17.85,17.85,0,0,1,5.49-8,29.55,29.55,0,0,1,9.83-5.8,10.52,10.52,0,0,1,4.42-.75,4.64,4.64,0,0,1,3.71,2.24c1,2,.05,4.37-1,6.32a73.81,73.81,0,0,1-6.46,9.84c-1.93,2.49-4.15,5-7.1,6.08s-6,1-7.58-1",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.56,448.31a7.1,7.1,0,0,1-.17-1.26c-.09-.91-.2-2.06-.34-3.43a50.09,50.09,0,0,0-.77-5,39.47,39.47,0,0,0-1.83-5.94,21.69,21.69,0,0,0-3-5.38,10.77,10.77,0,0,0-7.06-4.2,5.6,5.6,0,0,1-1.26-.18,6.65,6.65,0,0,1,1.28,0,9.9,9.9,0,0,1,3.37.88,11.32,11.32,0,0,1,4,3.22,21.65,21.65,0,0,1,3.14,5.48,36,36,0,0,1,1.82,6.05,43.83,43.83,0,0,1,.67,5.1c.11,1.45.15,2.63.17,3.45A5.22,5.22,0,0,1,587.56,448.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.33,445.67a2.39,2.39,0,0,1,0-.58c0-.44,0-1,0-1.67,0-1.45,0-3.55-.08-6.14-.13-5.18-.57-12.32-1.43-20.18s-2-14.93-3.07-20c-.25-1.27-.5-2.41-.73-3.42s-.42-1.87-.6-2.57-.29-1.19-.39-1.62a2.41,2.41,0,0,1-.1-.58,3,3,0,0,1,.2.55l.49,1.6c.21.7.43,1.56.68,2.56s.54,2.13.81,3.4a190.89,190.89,0,0,1,3.22,20c.87,7.88,1.25,15,1.29,20.23,0,2.6,0,4.7-.09,6.15,0,.68-.08,1.23-.1,1.67A3.39,3.39,0,0,1,587.33,445.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.29,431.84a12.19,12.19,0,0,1,0-1.74c.07-1.12.22-2.74.54-4.72a62.46,62.46,0,0,1,1.53-6.89,61.08,61.08,0,0,1,2.88-8.14,43.28,43.28,0,0,1,8.46-13.17,21.62,21.62,0,0,1,2-1.85c.31-.25.58-.51.85-.71l.78-.54a11.42,11.42,0,0,1,1.46-.94,54.57,54.57,0,0,0-4.81,4.3,45.83,45.83,0,0,0-8.24,13.11,65.08,65.08,0,0,0-2.9,8.07c-.75,2.53-1.25,4.86-1.63,6.82s-.57,3.57-.7,4.68A10.3,10.3,0,0,1,587.29,431.84Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--credit-card--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370,352.52,215.22,188.8a4.31,4.31,0,0,1,.17-6.08L317,86.68a4.3,4.3,0,0,1,6.08.17L477.85,250.58a4.31,4.31,0,0,1-.17,6.08l-101.59,96A4.29,4.29,0,0,1,370,352.52Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370,352.52,215.22,188.8a4.31,4.31,0,0,1,.17-6.08L317,86.68a4.3,4.3,0,0,1,6.08.17L477.85,250.58a4.31,4.31,0,0,1-.17,6.08l-101.59,96A4.29,4.29,0,0,1,370,352.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M476.71,249.38,324.19,88.05a5.94,5.94,0,0,0-8.41-.24L286.92,115.1a2.37,2.37,0,0,0-.72,2.12c2.89,16.14,14.43,30.57,28.19,40.13,16.62,11.55,36.32,17.64,55,25.35s37.51,17.87,48.74,34.72c10.59,15.91,13.09,35.64,18.48,54A105.73,105.73,0,0,0,442.09,286a2.39,2.39,0,0,0,3.8.74l30.59-28.92A5.94,5.94,0,0,0,476.71,249.38Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.94,135c-1.38,1.31-3.22,1-5.2-1.13l-3.9-4.13,8-7.54,3.68,3.9c1.89,2,2,3.81.79,5a2.63,2.63,0,0,1-2.76.6A2.72,2.72,0,0,1,321.94,135Zm-.78-9.65-1.88,1.78L321,129c.85.9,1.63,1.09,2.26.5s.47-1.37-.38-2.27Zm-.79,7.61c.67-.63.51-1.45-.4-2.41l-2-2.15-2,1.86,2,2.16C318.91,133.38,319.69,133.61,320.37,133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.76,142.1l-3.51-3.71-2.38.91-1.78-1.89,11.34-4,1.72,1.83-4.6,11.11-1.84-1.94Zm.85-1.91,1.86-4.15-4.25,1.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.22,147l-8,7.54L334.81,153l1.09-8.55L331.05,149l-1.72-1.83,8-7.54,1.45,1.53-1.1,8.54,4.85-4.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.91,156.33l-2.13,0-2,1.91L338,156.39l8-7.55,1.73,1.84L344,154.2h7.07l1.94,2-6.68.06L345.23,164l-2-2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.34,164.88,286,163.41,284,165.23l-.71-.75,1.93-1.82-3.91-4.13.54-.52,8.53-.71.79.84-8.27.73,3,3.18,1.69-1.61.69.74-1.69,1.6,1.38,1.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.61,170.09c-1.23,1.15-3,1.16-4.68-.61a5.25,5.25,0,0,1-1.55-3.53l.94-.2a4.39,4.39,0,0,0,1.3,3.07c1.15,1.22,2.34,1.35,3.25.49s.87-2-.41-3.35l-.5-.52.56-.53,4.46-.37-3.54-3.75.67-.63,4.45,4.71-.53.5-4.57.39C293.86,167.41,293.78,169,292.61,170.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.26,176c-1.25,1.18-3,1.23-4.73-.56a5.17,5.17,0,0,1-1.54-3.52l.94-.2a4.34,4.34,0,0,0,1.28,3c1.17,1.25,2.4,1.34,3.29.49s1-2-.78-3.89l-1.48-1.56,4-3.09,3.79,4-.67.63L299.23,168l-2.58,1.95.89,1C299.63,173.07,299.55,174.73,298.26,176Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.39,182.38a3.13,3.13,0,0,1-4.61-.37c-1.84-1.95-1.49-4.28.82-6.47,2.49-2.35,5.07-2.22,6.95-.23a4.57,4.57,0,0,1,1.25,2.12l-.9.27a3.42,3.42,0,0,0-1-1.75c-1.49-1.58-3.46-1.64-5.45.24-.17.16-.37.37-.57.6a3.2,3.2,0,0,1,3.37,1.05C305.63,179.29,305.73,181.12,304.39,182.38Zm-.72-.72c1-.91.91-2.2-.16-3.33a2.33,2.33,0,0,0-3.38-.37c-.81.76-.94,2.15.26,3.41A2.2,2.2,0,0,0,303.67,181.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.17,200.28l.65-3.92-4,.42-.79-.84,4.89-.5.71-4.6.8.84-.6,3.69,3.72-.39.77.82-4.63.46-.75,4.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.45,205.87l.65-3.93-4,.42-.8-.84,4.89-.49.72-4.6.79.83-.59,3.69,3.71-.38.78.82-4.64.46-.75,4.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.73,211.45l.65-3.92-4,.42-.79-.84,4.88-.49.72-4.61.79.84-.59,3.69,3.72-.38.77.81-4.64.46-.75,4.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,217l.65-3.92-4,.42-.79-.84,4.88-.5.72-4.6.79.84-.59,3.69,3.72-.39.77.82-4.64.46-.74,4.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.25,236.33l.65-3.92-4,.42-.79-.84,4.88-.49.72-4.61.79.84-.59,3.69,3.72-.39.77.82-4.64.46-.75,4.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.53,241.92l.65-3.93-4,.42-.79-.83,4.88-.5.72-4.6.79.84-.59,3.69,3.72-.39.77.82-4.64.46-.75,4.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.81,247.51l.66-3.93-4,.42-.79-.84,4.88-.49.72-4.6.79.83-.59,3.69,3.72-.38.77.81-4.64.46-.74,4.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.1,253.09l.65-3.92-4,.42-.79-.84,4.88-.49.72-4.61.8.84-.6,3.69,3.72-.39.77.82-4.64.46-.74,4.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.8,263.49l-7.32,6.93-.72-.76,6.66-6.29-1.63-1.72.67-.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.81,275c-1.22,1.16-3,1.16-4.68-.61a5.25,5.25,0,0,1-1.55-3.53l.94-.2a4.47,4.47,0,0,0,1.3,3.08c1.15,1.21,2.35,1.35,3.26.49s.87-2-.42-3.36l-.49-.52.55-.52,4.46-.38-3.54-3.74.67-.64,4.45,4.71-.53.51-4.56.39C393.07,272.35,393,273.91,391.81,275Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.52,282.47,397.13,281l-1.92,1.82-.72-.75,1.93-1.82-3.91-4.13.55-.52,8.52-.7.79.83-8.27.73,3,3.18,1.69-1.6.7.73-1.7,1.6,1.39,1.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.6,289.31l-.67.63-4.86-5.14.54-.5,5.86.22c1.6.06,2.24-.25,2.74-.72.85-.81.81-1.9-.25-3a3.42,3.42,0,0,0-2.71-1.22l0-1a4.52,4.52,0,0,1,3.5,1.6c1.4,1.49,1.54,3.14.31,4.3-.7.66-1.53,1-3.42,1l-4.81-.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.65,171a2.65,2.65,0,0,1,4.34,2.21l-1-.06a1.55,1.55,0,0,0-.42-1.27,1.54,1.54,0,0,0-2.24,2.12,1.52,1.52,0,0,0,1.25.48v1a2.5,2.5,0,0,1-2-.86A2.47,2.47,0,0,1,260.65,171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.44,178l-1.54-1.62-1,.4-.78-.83,5-1.75.75.8-2,4.87L265,179Zm.37-.83.81-1.82-1.86.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.24,182.48l.33-1.6,0,0-.67-.7-1,.92-.77-.81,3.5-3.3,1.43,1.51c.88.93.95,2,.16,2.71a1.55,1.55,0,0,1-1.78.33l-.38,1.84Zm2.12-3.44-.63-.66-1.22,1.15.63.66c.46.49.93.52,1.31.17S270.82,179.53,270.36,179Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.69,183.32l.87-.3a2.78,2.78,0,0,0,.73,1.5c.45.48.79.52,1,.32.65-.62-1.72-2.22-.42-3.45.6-.56,1.54-.55,2.48.44a3.18,3.18,0,0,1,.84,1.51l-.85.33a2.73,2.73,0,0,0-.64-1.23c-.46-.48-.81-.49-1-.29-.64.61,1.72,2.23.44,3.44-.59.55-1.54.54-2.49-.46A3.49,3.49,0,0,1,269.69,183.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.49,188.43l-3.5,3.31-.76-.81,1.43-1.36-1.5-1.59-1.43,1.36-.77-.81,3.5-3.3.76.8-1.38,1.31,1.5,1.59,1.38-1.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.32,190.7a2.64,2.64,0,1,1,0,3.62A2.5,2.5,0,0,1,279.32,190.7Zm2.84,3a1.46,1.46,0,0,0,.09-2.15,1.54,1.54,0,1,0-.09,2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.27,193.49l.76.81L283.19,197l1.66,1.75-.66.62-2.42-2.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.12,196.51l1.5,1.59a2.41,2.41,0,1,1-3.49,3.3l-1.5-1.59Zm-1.37,4.22a1.5,1.5,0,1,0,2.17-2l-.7-.74L286.06,200Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.74,206l-.65.62-2.56-2.71,3.5-3.3,2.49,2.64-.64.61-1.74-1.83-.76.71,1.53,1.63-.63.59-1.53-1.62-.81.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.81,209.52l.33-1.59,0,0-.67-.7-1,.92-.77-.81,3.5-3.31,1.43,1.52c.88.93.95,2,.16,2.71a1.55,1.55,0,0,1-1.78.33l-.38,1.84Zm2.12-3.44-.63-.66-1.21,1.16.62.66c.47.49.93.52,1.31.16S296.39,206.58,295.93,206.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.66,183.52l1.86-.12a2.15,2.15,0,0,0,.44,1.95c.59.62,1.28.6,2-.1l3.2-3-2.24-2.37,1.25-1.18,3.71,3.92-4.37,4.12c-1.67,1.58-3.27,1.51-4.77-.07A3.73,3.73,0,0,1,246.66,183.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,189.13a1.28,1.28,0,0,1,1.76,1.86,1.28,1.28,0,1,1-1.76-1.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.94,196.38l-8.82,4.16-1.58-1.67,3.16-5.79-6,2.78-1.57-1.66,4.64-8.58,1.53,1.61-3.3,6,6.24-2.89,1.36,1.44-3.32,6.05,6.26-2.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.57,197.05a1.16,1.16,0,0,1,1.71.14,1.15,1.15,0,0,1,.08,1.69,1.18,1.18,0,0,1-1.75-.11A1.17,1.17,0,0,1,270.57,197.05Zm-1.39,1.65,1.42,1.5-5.18,4.89-1.41-1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.88,199.74l1.42,1.5L268.16,208l-1.42-1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.61,202.63l1.42,1.5-7.14,6.75-1.42-1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.77,205.72a1.19,1.19,0,0,1,1.72.14,1.17,1.17,0,0,1,.07,1.7,1.29,1.29,0,0,1-1.79-1.84Zm-1.39,1.66,1.42,1.5-5.17,4.89-1.42-1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.22,217l-3,2.79-1.33-1.4.65-.61a2.34,2.34,0,0,1-2.21-.9c-1.15-1.21-1.16-2.57-.26-3.41s2.15-.82,3.64.75l1.13,1.2c.65-.61.66-1.35-.11-2.16a3.41,3.41,0,0,0-1.89-1l.54-1.52a5.47,5.47,0,0,1,2.74,1.63C283.66,213.86,283.79,215.47,282.22,217Zm-2.73-.25.53-.5-1-1c-.66-.71-1.13-.68-1.48-.36s-.32.91.18,1.44A1.53,1.53,0,0,0,279.49,216.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.78,227l-3,2.8-1.41-1.5,2.73-2.58c.83-.79.86-1.53.29-2.13s-1.51-.74-2.44.13l-2.59,2.46-1.42-1.5,2.73-2.58c.84-.8.88-1.52.29-2.14s-1.5-.73-2.43.15L282,222.59l-1.42-1.5,5.17-4.89,1.36,1.43-.6.57a2.86,2.86,0,0,1,2.21,1,2.66,2.66,0,0,1,.76,2.51,3.21,3.21,0,0,1,2.62,1.06C293.23,224,293.35,225.54,291.78,227Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.09,230.22l1.55-.52a4.79,4.79,0,0,0,1.2,2.27c.65.69,1.08.78,1.37.51.84-.8-3-3.11-.91-5.07,1-.92,2.51-.69,3.94.82a5.89,5.89,0,0,1,1.43,2.42l-1.54.51a4,4,0,0,0-1-1.86c-.63-.67-1.12-.76-1.39-.51-.88.84,2.93,3.16.89,5.08-1,.91-2.49.67-4-.88A6.05,6.05,0,0,1,290.09,230.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.84,288.05c2.22-2.1,4.64-2.06,6.21-.41s1.47,4.08-.76,6.18-4.63,2.07-6.21.41S347.62,290.15,349.84,288.05Zm4,4.2c1.53-1.44,1.66-2.58.92-3.36s-1.87-.71-3.4.74-1.66,2.58-.93,3.35S352.28,293.7,353.81,292.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,301.31c-1.37,1.3-3.3,1-4.65-.43-1.75-1.86-1.68-4.12.49-6.17,2.33-2.2,5-2,6.87,0a5,5,0,0,1,1.32,2.32l-1.69.5a3.12,3.12,0,0,0-.86-1.58,2.46,2.46,0,0,0-3.74-.05,3.2,3.2,0,0,1,2.17,1.1A3,3,0,0,1,360,301.31Zm-1.5-1.44a1.4,1.4,0,0,0-.08-2.1,1.45,1.45,0,0,0-2.11-.21,1.43,1.43,0,0,0,.12,2.13A1.4,1.4,0,0,0,358.52,299.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,298.8l1.27,1.33-12.07,5.4-1.26-1.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.1,311.57l-1.27,1.2L362,307.68l1-.95,4.91.28a2.34,2.34,0,0,0,1.91-.47c.53-.5.49-1.16-.19-1.87a2.25,2.25,0,0,0-2-.76l-.34-1.83a4.31,4.31,0,0,1,3.78,1.49c1.42,1.51,1.59,3.23.37,4.39-.65.62-1.42,1-3.19.88l-2.92-.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.59,318.14l-1-1.09-1.41,1.33-1.44-1.52,1.42-1.33-3.43-3.63,1.05-1,7.27-.86,1.55,1.63-6.84.88,1.71,1.81,1.26-1.19,1.39,1.47-1.26,1.19,1,1.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.18,234.85c3.8-5.84,2.31-13.6-2.79-18.34a18.12,18.12,0,0,0-5.31-3.48c-4.87-2-11.32-.55-13.88,4.07-2.09,3.77-1.25,8.48.22,12.53,1.53,4.25,4,8.59,8.21,10.24s8.92.14,11.94-3A12.6,12.6,0,0,0,406.18,234.85Z",
    style: {
      fill: "#D63C6D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wallet--inject-33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.76,
    y: 237.26,
    width: 290.61,
    height: 210.91,
    rx: 17.44,
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.37,254.7s0-.21,0-.63a14.13,14.13,0,0,0-.18-1.87,17.06,17.06,0,0,0-2.56-6.83,18.19,18.19,0,0,0-3.56-4.05,17.64,17.64,0,0,0-5.69-3.12c-.56-.19-1.15-.3-1.74-.47s-1.22-.19-1.85-.29l-1.93-.09H488.08l-104.27.08-72,0-40.12,0H245.38a27.61,27.61,0,0,0-5.31.3,17.06,17.06,0,0,0-9.26,5,16.77,16.77,0,0,0-3.07,4.41,16.3,16.3,0,0,0-1.56,5.17,43.53,43.53,0,0,0-.17,5.5V286q0,22.86,0,46.63v98A17.31,17.31,0,0,0,230.29,442a17,17,0,0,0,10.59,5.71,52.5,52.5,0,0,0,6.16.17H405.2l82.65,0h9.62a24.34,24.34,0,0,0,4.69-.31,17.21,17.21,0,0,0,4.39-1.48,18.76,18.76,0,0,0,2-1.14,20.81,20.81,0,0,0,1.8-1.42,17.07,17.07,0,0,0,5.77-11.88c.1-12,0-23.54.06-34.54,0-44,.07-79.64.09-104.26,0-12.31,0-21.86.05-28.35,0-3.23,0-5.7,0-7.37s0-2.51,0-2.51,0,.85,0,2.51,0,4.14,0,7.37c0,6.49,0,16,.05,28.35,0,24.62,0,60.24.08,104.26,0,11,.07,22.53,0,34.56a17.53,17.53,0,0,1-2.84,8.65,17.91,17.91,0,0,1-3,3.52,20,20,0,0,1-1.85,1.45,19.72,19.72,0,0,1-2,1.17,17.24,17.24,0,0,1-4.49,1.52,23.87,23.87,0,0,1-4.77.32h-9.62l-82.65,0-91.34,0H247a52.1,52.1,0,0,1-6.23-.18,17.44,17.44,0,0,1-10.91-5.87,17.84,17.84,0,0,1-4.4-11.67c0-33.59,0-66.37,0-98V286q0-11.42,0-22.6v-5.57a43.26,43.26,0,0,1,.18-5.57,16.68,16.68,0,0,1,1.61-5.31,17.05,17.05,0,0,1,3.16-4.54,18.51,18.51,0,0,1,4.36-3.32,18,18,0,0,1,5.16-1.8l1.35-.21,1.35-.07c.91-.05,1.8,0,2.69,0h66.43l72,0,104.27.09h10.73l1.95.1c.63.11,1.26.18,1.86.31s1.19.28,1.75.48a17.7,17.7,0,0,1,5.73,3.16,18.14,18.14,0,0,1,3.57,4.09,17,17,0,0,1,2.52,6.88,12.1,12.1,0,0,1,.16,1.88C516.37,254.49,516.37,254.7,516.37,254.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.19,250.26a17.44,17.44,0,0,1,6,0,17.44,17.44,0,0,1-6,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.71,250.26a72.16,72.16,0,0,1,12.24,0,72.16,72.16,0,0,1-12.24,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.24,250.26a72,72,0,0,1,12.23,0,72,72,0,0,1-12.23,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.76,250.26a72.16,72.16,0,0,1,12.24,0,72.16,72.16,0,0,1-12.24,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.29,250.26a72,72,0,0,1,12.23,0,72,72,0,0,1-12.23,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.81,250.26a72.16,72.16,0,0,1,12.24,0,72.16,72.16,0,0,1-12.24,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.34,250.26a72,72,0,0,1,12.23,0,72,72,0,0,1-12.23,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.86,250.26a72.16,72.16,0,0,1,12.24,0,72.16,72.16,0,0,1-12.24,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.38,250.26a72.16,72.16,0,0,1,12.24,0,72.16,72.16,0,0,1-12.24,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.91,250.26A36.7,36.7,0,0,1,292,250a36.7,36.7,0,0,1,6.12.26,35.45,35.45,0,0,1-6.12.26A35.45,35.45,0,0,1,285.91,250.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.43,250.26a36.7,36.7,0,0,1,6.12-.26,36.7,36.7,0,0,1,6.12.26,35.45,35.45,0,0,1-6.12.26A35.45,35.45,0,0,1,261.43,250.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,256.26a34,34,0,0,1-.26-6l.26-.26h2.33l1.91.06a6.41,6.41,0,0,1,1.76.18,6.14,6.14,0,0,1-1.76.19l-1.91.05-1.12,0H243.2l.26-.26A35.22,35.22,0,0,1,243.2,256.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,278.69a29.81,29.81,0,0,1-.26-5.61,29.75,29.75,0,0,1,.26-5.6,30.79,30.79,0,0,1,.26,5.6A30.86,30.86,0,0,1,243.2,278.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,301.12a60.55,60.55,0,0,1,0-11.21,60.55,60.55,0,0,1,0,11.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,323.55a60.65,60.65,0,0,1,0-11.22,60.65,60.65,0,0,1,0,11.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,346a60.65,60.65,0,0,1,0-11.22,60.65,60.65,0,0,1,0,11.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,368.4a60.55,60.55,0,0,1,0-11.21,60.55,60.55,0,0,1,0,11.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,390.83a60.55,60.55,0,0,1,0-11.21,60.55,60.55,0,0,1,0,11.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,413.26a60.55,60.55,0,0,1,0-11.21,60.55,60.55,0,0,1,0,11.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2,430.48a35.32,35.32,0,0,1-6,.26c-.52-.52-.15-.15-.26-.27h0v-1.19c0-.39,0-.76,0-1.13,0-.66,0-1.29,0-1.91a5.63,5.63,0,0,1,.19-1.75,6.3,6.3,0,0,1,.18,1.75c0,.62,0,1.25.06,1.91,0,.37,0,.74,0,1.13,0,.19,0,.39,0,.59v.6h0c-.12-.11.26.27-.26-.25A34.12,34.12,0,0,1,249.2,430.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.32,430.48a35.64,35.64,0,0,1-6,.26,35.64,35.64,0,0,1-6-.26,34.43,34.43,0,0,1,6-.26A34.43,34.43,0,0,1,273.32,430.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.44,430.48a35.64,35.64,0,0,1-6,.26,35.64,35.64,0,0,1-6-.26,34.43,34.43,0,0,1,6-.26A34.43,34.43,0,0,1,297.44,430.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.56,430.48a70.05,70.05,0,0,1-12.06,0,70.05,70.05,0,0,1,12.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.68,430.48a70.05,70.05,0,0,1-12.06,0,70.05,70.05,0,0,1,12.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.8,430.48a70.05,70.05,0,0,1-12.06,0,70.05,70.05,0,0,1,12.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.92,430.48a70.05,70.05,0,0,1-12.06,0,70.05,70.05,0,0,1,12.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,430.48a70.05,70.05,0,0,1-12.06,0,70.05,70.05,0,0,1,12.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.16,430.48a70.05,70.05,0,0,1-12.06,0,70.05,70.05,0,0,1,12.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.28,430.48a70.05,70.05,0,0,1-12.06,0,70.05,70.05,0,0,1,12.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.41,430.48a70.05,70.05,0,0,1-12.06,0,70.05,70.05,0,0,1,12.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.47,430.48a17.44,17.44,0,0,1-6,0,17.44,17.44,0,0,1,6,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M326,354.24s.06,10-3,16-4,8.38-10.4,10.7-86.92,11.17-86.92,11.17V364.94Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M324.59,316.54s.92-10.21-24.69-14c-29.29-4.33-74.14-9.65-74.14-9.65V312.2Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 214.11,
    y: 307.28,
    width: 111.93,
    height: 65.92,
    rx: 14.31,
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.42,373.19s-.29,0-.85,0a12.94,12.94,0,0,1-2.49-.34,13.79,13.79,0,0,1-3.81-1.48,14.17,14.17,0,0,1-4.21-3.63,14.35,14.35,0,0,1-2.85-6.35,20.83,20.83,0,0,1-.24-4c0-1.38,0-2.82,0-4.31,0-5.95,0-12.72,0-20.21,0-3.75,0-7.66,0-11.76a14.48,14.48,0,0,1,5.74-11.1,14.14,14.14,0,0,1,6.19-2.72,18.25,18.25,0,0,1,3.46-.24h18l64.44,0a14.5,14.5,0,0,1,11.32,5.4,14.41,14.41,0,0,1,3.18,7.75c.11,1.41.07,2.78.08,4.15q0,4.11,0,8.15v15.87c0,2.59,0,5.16,0,7.69,0,1.28.05,2.52,0,3.8a15,15,0,0,1-.23,1.89,18.81,18.81,0,0,1-.5,1.82A14.57,14.57,0,0,1,315.08,373a17.32,17.32,0,0,1-1.75.31c-.59.05-1.18.07-1.77.09H301.41l-24.5,0-35.48-.09-9.65-.05-2.5,0-.86,0s.29,0,.86,0l2.5,0,9.65-.05,35.48-.08,24.5,0h6.71c2.28-.06,4.61.19,6.85-.4a14.11,14.11,0,0,0,10.08-9.18c.86-2.31.74-4.82.74-7.36v-7.69c0-5.18,0-10.48,0-15.87v-8.15c0-1.37,0-2.76-.07-4.1a14.07,14.07,0,0,0-3.07-7.48,15.52,15.52,0,0,0-3-2.79,15.21,15.21,0,0,0-3.75-1.79,15.58,15.58,0,0,0-4.13-.62l-64.44,0h-18a18.11,18.11,0,0,0-3.39.23,13.76,13.76,0,0,0-6,2.62,14.08,14.08,0,0,0-5.6,10.77c-.05,4.07,0,8,0,11.75,0,7.49,0,14.26,0,20.21,0,1.49,0,2.93,0,4.31a21.12,21.12,0,0,0,.22,3.95,14.3,14.3,0,0,0,10.64,11.4,13.57,13.57,0,0,0,2.47.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.32,
    cy: 342.72,
    r: 23.96,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.46,362.29a25.34,25.34,0,0,0,5.72-3,20.7,20.7,0,0,0,4.84-5A18.78,18.78,0,0,0,311.61,338a20.35,20.35,0,0,0-3.06-6.25,24.78,24.78,0,0,0-4.5-4.62s.15.06.39.22a12,12,0,0,1,1.07.75,18.24,18.24,0,0,1,3.34,3.43,20.27,20.27,0,0,1,3.22,6.33,18.83,18.83,0,0,1-2.66,16.7,20.25,20.25,0,0,1-5,5,17.73,17.73,0,0,1-4.24,2.21,10.58,10.58,0,0,1-1.24.39A1.26,1.26,0,0,1,298.46,362.29Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.42,189.14a44.27,44.27,0,1,1-48-40A44.22,44.22,0,0,1,667.42,189.14Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M656.82,189c-.2,0-.47-1.43-1.24-4a36,36,0,0,0-4.8-9.95,34.42,34.42,0,0,0-5-5.71,33.64,33.64,0,0,0-7.1-5,31.35,31.35,0,0,0-4.3-1.87,32.6,32.6,0,0,0-4.71-1.27,33.08,33.08,0,0,0-5-.57,35,35,0,0,0-5.2.21,37.14,37.14,0,0,0-5.1,1,33.47,33.47,0,0,0-4.74,1.76,32.83,32.83,0,0,0-8,5.2,33.74,33.74,0,0,0-5.72,6.51,34.4,34.4,0,0,0-3.48,6.74,35.55,35.55,0,0,0-2.28,10.8c-.15,2.64-.06,4.12-.27,4.15s-.57-1.43-.74-4.15a31.29,31.29,0,0,1,1.56-11.41,33.68,33.68,0,0,1,9.34-14.4,34.44,34.44,0,0,1,8.52-5.73,34.18,34.18,0,0,1,5.1-1.93,37,37,0,0,1,5.5-1.13,37.87,37.87,0,0,1,5.61-.22,35.68,35.68,0,0,1,5.42.66,34.56,34.56,0,0,1,9.64,3.52,33.82,33.82,0,0,1,12.51,11.76,31.17,31.17,0,0,1,4.24,10.71C657,187.5,657,189,656.82,189Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M628.92,212.78l.61,5.84-5.22.55-.59-5.69c-5.2.22-10.32-.88-13.42-2.82l2.2-6.67A21.17,21.17,0,0,0,623,206.64l-.91-8.71c-5.93-.81-12.6-2.06-13.38-9.53-.58-5.53,2.95-10.69,11.09-12.49l-.6-5.79,5.22-.54.59,5.68a23.86,23.86,0,0,1,10.92,2.08L634,184a21.53,21.53,0,0,0-8.26-1.88l.92,8.87c5.93.75,12.5,2,13.26,9.38C640.49,205.83,637,210.94,628.92,212.78Zm-7.61-22.52-.78-7.41c-2.69.91-3.63,2.54-3.45,4.26S618.93,189.77,621.31,190.26Zm10.28,11.64c-.19-1.83-1.81-2.66-4.13-3.21l.75,7.2C630.76,205.05,631.76,203.57,631.59,201.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M589.74,196.17a1.23,1.23,0,0,1,.07.27c0,.21.08.47.14.79s.12.79.2,1.28a14.46,14.46,0,0,0,.35,1.74,34.12,34.12,0,0,0,9.12,16.46l1.58,1.44c.27.23.52.49.81.72l.89.66c.6.44,1.19.93,1.83,1.34l2,1.21a34.17,34.17,0,0,0,9.15,3.55,33.42,33.42,0,0,0,20.73-1.91,34.14,34.14,0,0,0,8.35-5.16l1.74-1.55c.56-.52,1-1.11,1.55-1.65.25-.27.51-.54.75-.81s.45-.58.68-.86c.43-.58.86-1.14,1.29-1.7a35.44,35.44,0,0,0,3.63-6.86,34,34,0,0,0,2.33-11,13.3,13.3,0,0,0,0-1.77c0-.5,0-.94,0-1.3s0-.59,0-.8a1.58,1.58,0,0,1,0-.28,1.14,1.14,0,0,1,0,.27c0,.21,0,.48.06.8s0,.8.07,1.31a11.37,11.37,0,0,1,0,1.78,32.91,32.91,0,0,1-2.19,11.11,34.23,34.23,0,0,1-3.62,7L650,214c-.23.29-.44.6-.68.88l-.76.83c-.51.55-1,1.14-1.57,1.67l-1.75,1.59a34.56,34.56,0,0,1-8.46,5.26,33.74,33.74,0,0,1-21,1.94,34.27,34.27,0,0,1-9.28-3.64l-2-1.23c-.65-.42-1.24-.92-1.85-1.36l-.89-.68c-.29-.23-.55-.5-.83-.74L599.31,217a35.06,35.06,0,0,1-4.83-6.2,33,33,0,0,1-4.18-10.53,12.12,12.12,0,0,1-.3-1.75c-.06-.5-.11-.94-.16-1.3s-.06-.59-.09-.8A1.37,1.37,0,0,1,589.74,196.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605,319.65a25.72,25.72,0,1,1-12-34.28A25.68,25.68,0,0,1,605,319.65Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M599.79,316.44a11.43,11.43,0,0,1,.56-2.35,21,21,0,0,0,.57-6.39,20.69,20.69,0,0,0-.79-4.34,19.79,19.79,0,0,0-2.07-4.59,19.19,19.19,0,0,0-1.59-2.21,19.23,19.23,0,0,0-7-5.26,20.16,20.16,0,0,0-2.85-1,19.53,19.53,0,0,0-2.89-.53,18,18,0,0,0-2.83-.1,18.26,18.26,0,0,0-2.71.31,19.22,19.22,0,0,0-4.79,1.54,20.48,20.48,0,0,0-3.75,2.32,20.88,20.88,0,0,0-4.35,4.72,12.2,12.2,0,0,1-1.37,2,5.71,5.71,0,0,1,.87-2.29A18,18,0,0,1,569,293a19.39,19.39,0,0,1,3.87-2.62,20.08,20.08,0,0,1,5.07-1.79,20,20,0,0,1,6-.32,20.26,20.26,0,0,1,3.12.56,22.1,22.1,0,0,1,3.08,1.08,21.36,21.36,0,0,1,2.87,1.56,20.06,20.06,0,0,1,2.5,1.94,18.33,18.33,0,0,1,2.1,2.23,18.72,18.72,0,0,1,1.66,2.4,20.06,20.06,0,0,1,2.09,5,19.81,19.81,0,0,1,.65,4.62,18.14,18.14,0,0,1-1.07,6.61A6,6,0,0,1,599.79,316.44Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M578.79,320l-1.43,3.09-2.77-1.28,1.4-3a14.52,14.52,0,0,1-5.86-5.41l3.09-2.67a12.34,12.34,0,0,0,4.45,4.46l2.15-4.62c-2.73-2.17-5.68-4.79-3.84-8.74,1.36-2.93,4.65-4.46,9.25-2.93l1.43-3.07,2.76,1.29-1.4,3a13.79,13.79,0,0,1,4.83,4.29l-3,2.76a12.54,12.54,0,0,0-3.56-3.4l-2.18,4.7c2.73,2.14,5.63,4.73,3.82,8.63C586.64,320,583.38,321.47,578.79,320Zm2.91-13.51,1.83-3.92c-1.62-.35-2.58.18-3,1.09S580.67,305.52,581.7,306.47Zm1.67,8.88c.44-1-.11-1.87-1.11-2.84l-1.77,3.82C582,316.67,583,316.23,583.37,315.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M564.19,300s-.3.81-.79,2.28a19.66,19.66,0,0,0-.92,6.44,20.44,20.44,0,0,0,.61,4.45A21.11,21.11,0,0,0,565,318a20,20,0,0,0,3.5,4.47,19.25,19.25,0,0,0,10.85,5.2,19.86,19.86,0,0,0,5.67-.08,19.42,19.42,0,0,0,8.78-3.79,20,20,0,0,0,4.45-4.75c.83-1.3,1.22-2.08,1.27-2.05a2.54,2.54,0,0,1-.25.57,16.1,16.1,0,0,1-.85,1.58,19.12,19.12,0,0,1-4.39,4.94,19.26,19.26,0,0,1-8.93,4,19.8,19.8,0,0,1-5.82.11,21.2,21.2,0,0,1-6-1.77,21,21,0,0,1-5.13-3.56,20.11,20.11,0,0,1-3.56-4.6,20.94,20.94,0,0,1-2-4.9,20.43,20.43,0,0,1-.55-4.55,18.75,18.75,0,0,1,1.09-6.51,13.07,13.07,0,0,1,.7-1.65A3.13,3.13,0,0,1,564.19,300Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.44,316a42,42,0,1,1-47.57-35.41A41.93,41.93,0,0,1,180.44,316Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170.4,316.42c-.19,0-.53-1.33-1.39-3.68a33.68,33.68,0,0,0-5.06-9.18,33.18,33.18,0,0,0-5-5.14,31.77,31.77,0,0,0-7-4.32,29.09,29.09,0,0,0-4.17-1.54,29.82,29.82,0,0,0-4.53-1,31.4,31.4,0,0,0-4.78-.28,34.29,34.29,0,0,0-4.91.48,33.48,33.48,0,0,0-4.78,1.24,32.81,32.81,0,0,0-4.4,1.91,29.88,29.88,0,0,0-3.92,2.47,30.79,30.79,0,0,0-3.39,2.88,31.8,31.8,0,0,0-8,13,33.69,33.69,0,0,0-1.59,10.36c0,2.5.15,3.9,0,3.93s-.62-1.32-.91-3.88a29.2,29.2,0,0,1,.88-10.89,32.12,32.12,0,0,1,2.84-7.08,33,33,0,0,1,5.24-7.05,31.2,31.2,0,0,1,3.58-3.16,32,32,0,0,1,4.19-2.71,32.46,32.46,0,0,1,4.73-2.09,32.61,32.61,0,0,1,10.46-1.86,33.81,33.81,0,0,1,5.16.34,30.79,30.79,0,0,1,4.87,1.1,32.36,32.36,0,0,1,4.45,1.73,32.15,32.15,0,0,1,12.46,10.48,29.87,29.87,0,0,1,4.58,9.93C170.53,315,170.54,316.4,170.4,316.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.22,340.38l.88,5.5-4.91.79-.86-5.36c-4.91.48-9.82-.29-12.86-2l1.74-6.43a20,20,0,0,0,10.09,2l-1.31-8.2c-5.67-.45-12.05-1.3-13.18-8.32-.83-5.21,2.24-10.29,9.86-12.41l-.88-5.46,4.92-.78.85,5.35a22.68,22.68,0,0,1,10.46,1.4l-1.49,6.44a20.38,20.38,0,0,0-7.93-1.35l1.34,8.35c5.66.4,11.94,1.26,13.05,8.19C155.81,333.19,152.78,338.21,145.22,340.38Zm-8.39-20.93-1.12-7c-2.51,1-3.31,2.6-3.05,4.22S134.56,319.11,136.83,319.45Zm10.35,10.49c-.28-1.72-1.85-2.43-4.08-2.83l1.08,6.78C146.55,333,147.43,331.51,147.18,329.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M107.25,326.7a1.61,1.61,0,0,1,.07.25c.05.19.11.44.18.74l.26,1.2a14.07,14.07,0,0,0,.42,1.63,32.22,32.22,0,0,0,4.61,9.6,33,33,0,0,0,4.89,5.5l1.57,1.28c.27.21.53.44.81.64l.88.58c.59.38,1.17.81,1.8,1.17l1.94,1a32.61,32.61,0,0,0,8.85,2.89,34.39,34.39,0,0,0,10,.11,34.74,34.74,0,0,0,9.54-3,32.73,32.73,0,0,0,7.63-5.32l1.56-1.57c.51-.52.93-1.1,1.39-1.63l.67-.81c.22-.28.4-.57.59-.85.39-.57.76-1.13,1.14-1.68a34,34,0,0,0,3.08-6.68,32.16,32.16,0,0,0,1.63-10.53,11,11,0,0,0-.07-1.68c0-.47-.07-.88-.09-1.23s0-.55-.05-.76a.86.86,0,0,1,0-.26.82.82,0,0,1,.05.26c0,.2.06.45.1.75s.09.76.15,1.23a12,12,0,0,1,.11,1.69,31,31,0,0,1-1.48,10.64,32.76,32.76,0,0,1-3.07,6.8l-1.13,1.7c-.2.29-.38.59-.6.87l-.67.82c-.46.55-.89,1.14-1.4,1.67s-1,1.06-1.58,1.59a32.8,32.8,0,0,1-7.74,5.44,32,32,0,0,1-19.83,2.93,32.91,32.91,0,0,1-9-3l-2-1.07c-.64-.36-1.22-.8-1.82-1.19l-.89-.59c-.28-.21-.54-.45-.82-.66l-1.58-1.3a33.17,33.17,0,0,1-4.9-5.62,31.22,31.22,0,0,1-4.5-9.76,10.34,10.34,0,0,1-.38-1.65c-.08-.47-.15-.87-.22-1.22l-.12-.75A1,1,0,0,1,107.25,326.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M708.47,448.2c0,.15-149.31.27-333.45.27s-333.49-.12-333.49-.27,149.28-.26,333.49-.26S708.47,448.06,708.47,448.2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553,260.34s-.07-6.65-.36-6.71L539,256.68c-.15.86-1.87,11.78-1.58,12.84l15.39,4.27S553,260.73,553,260.34Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553,272.78a.66.66,0,0,0,.06-.3c.16-1.49.07-8-.73-8.27s-3.11.19-3.26,1.05.37,8.18.37,8.18.15,1.15,2.09,1.43C552.75,275,553,272.78,553,272.78Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.12,275.12a.66.66,0,0,0,.06-.3c.16-1.49.07-8-.73-8.28s-3.11.2-3.26,1.06.37,8.18.37,8.18.15,1.15,2.09,1.43C548.85,277.38,549.12,275.12,549.12,275.12Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.3,276.28s.05-.12.07-.3c.16-1.49.06-8-.73-8.27s-3.12.2-3.27,1.06.37,8.17.37,8.17.15,1.16,2.09,1.44C545,278.55,545.3,276.28,545.3,276.28Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.5,277.38s0-.12.07-.3c.16-1.49.06-8-.73-8.27s-3.11.2-3.27,1.05.37,8.18.37,8.18.16,1.15,2.1,1.43C541.24,279.65,541.5,277.38,541.5,277.38Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.06,267.16a12.75,12.75,0,0,1,.3,3.17,12,12,0,0,1-.1,3.13,12.75,12.75,0,0,1-.3-3.17A12,12,0,0,1,549.06,267.16Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.22,267.14a24.18,24.18,0,0,1,.37,4.5,23.9,23.9,0,0,1-.05,4.52,25.87,25.87,0,0,1-.36-4.5A25.51,25.51,0,0,1,545.22,267.14Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.78
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.33,267.46a25.87,25.87,0,0,1,.36,4.5,25.56,25.56,0,0,1,0,4.52,25.25,25.25,0,0,1-.37-4.5A26.09,26.09,0,0,1,541.33,267.46Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M538.88,257s-5.41,12.3-4.62,13.07a18.13,18.13,0,0,0,3.33,1.93Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509,92.08l-4,46-23-1.84c-.15-2.69.05-13.1.05-13.1s-9.59-1.49-9.71-11.07c-.05-4.65.61-14.27,1.31-22.94a17.74,17.74,0,0,1,18.71-16.28h0A17.74,17.74,0,0,1,509,92.08Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,123a22.26,22.26,0,0,0,12.49-3.56s-3,6.9-12.51,6Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.15,95.85a1.38,1.38,0,0,0,1.32,1.38A1.3,1.3,0,0,0,478.88,96a1.36,1.36,0,0,0-1.31-1.39A1.32,1.32,0,0,0,476.15,95.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.65,94c.17.18,1.21-.59,2.68-.58s2.55.74,2.71.56-.09-.4-.56-.75a3.84,3.84,0,0,0-2.18-.67,3.71,3.71,0,0,0-2.13.69C475.72,93.56,475.57,93.88,475.65,94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.65,95.85A1.38,1.38,0,0,0,492,97.23,1.3,1.3,0,0,0,493.38,96a1.36,1.36,0,0,0-1.31-1.39A1.32,1.32,0,0,0,490.65,95.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.12,94.24c.17.18,1.21-.59,2.68-.59s2.56.74,2.72.56-.1-.4-.57-.74a3.77,3.77,0,0,0-2.17-.67,3.52,3.52,0,0,0-2.13.69C490.2,93.84,490,94.16,490.12,94.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.78,105.16a10,10,0,0,0-2.39-.43c-.38,0-.73-.12-.8-.37a1.94,1.94,0,0,1,.25-1.12l1.12-2.86c1.54-4.08,2.66-7.43,2.49-7.49s-1.55,3.19-3.09,7.27c-.37,1-.73,2-1.07,2.88a2.21,2.21,0,0,0-.19,1.48,1,1,0,0,0,.62.55,3.27,3.27,0,0,0,.64.09A9.68,9.68,0,0,0,484.78,105.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.11,106.18c-.24,0-.24,1.58-1.61,2.72s-3.07,1-3.08,1.18.38.31,1.1.33a4,4,0,0,0,2.57-.9,3.41,3.41,0,0,0,1.25-2.28C489.4,106.56,489.22,106.17,489.11,106.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.74,88.47c.15.4,1.62.21,3.35.42s3.12.68,3.35.32c.1-.18-.14-.55-.7-.94a5.85,5.85,0,0,0-5.1-.56C490,88,489.68,88.28,489.74,88.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.19,89.7c.26.34,1.27,0,2.49,0s2.26.23,2.5-.12c.1-.17-.06-.51-.51-.82a3.62,3.62,0,0,0-4,.12C476.22,89.19,476.08,89.54,476.19,89.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,86.16c-.55,4.65-1.82,10.54-2.19,15.3a2.38,2.38,0,0,1-.34,1.26c-.68.9-2.31,2.86-3.14,2.08-2-1.88-2.8-7.14-3.21-9.87s-.33-5.51-.7-8.25l0-.19a7.55,7.55,0,0,0-2.79-4.86,4.8,4.8,0,0,0-1.12-.59c-2.82-1-7.51.84-10.32,1.86-1.44.53-2.85,1.18-4.25,1.82a9.92,9.92,0,0,1-9.89-.83c-1.71-1.24-1.86-5.15-1.11-7.62,2-6.67,10.41-9,21.18-6.42S512.1,76.58,511,86.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.72,96.42c.16-.07,6.58-2,6.37,4.6s-6.74,5-6.75,4.81S505.72,96.42,505.72,96.42Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.43,103.41s.11.08.3.18a1.13,1.13,0,0,0,.85,0,2.82,2.82,0,0,0,1.39-2.49,3.82,3.82,0,0,0-.27-1.65,1.3,1.3,0,0,0-.83-.9.58.58,0,0,0-.68.29c-.1.18-.06.31-.1.32s-.13-.11-.07-.38a.7.7,0,0,1,.27-.4.89.89,0,0,1,.64-.15,1.61,1.61,0,0,1,1.16,1.06,3.89,3.89,0,0,1,.33,1.83,3,3,0,0,1-1.75,2.78,1.17,1.17,0,0,1-1-.21C507.43,103.57,507.4,103.42,507.43,103.41Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.9,86.6a10.08,10.08,0,0,1-9.41.17,28.08,28.08,0,0,0,4.72.56A28.67,28.67,0,0,0,510.9,86.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.67,88.48a7.7,7.7,0,0,1-4.48,1.25,7.8,7.8,0,0,1-4.54-1.08,28.12,28.12,0,0,0,4.53.55A27,27,0,0,0,510.67,88.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.08,414.85l4.26,19.61s-18.5,10.91-18.06,14.61l38.3-6.89-5.38-30.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.58,442.18l-.66-3.09-36.48,7.76s-1.57,1-1.16,2.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.65,417l.63,20.05s-20.17,7.38-20.41,11.09l38.92.17.3-31.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.79,448.32l-.09-3.15-37.28,1s-1.74.74-1.55,2Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M463,431.67S443,333.8,443,331.84L478.66,313l13.8,114.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.86,435,480.31,265.33V228.74l37.64,3.5c.48,1.42,12.8,202.93,12.8,202.93l-3.88-.22h-19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.64 226.15 443.02 331.84 477.95 323.37 492.18 229.59 458.64 226.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491,235.11s0,.18,0,.52.09.87.16,1.52c.16,1.35.38,3.31.67,5.82.59,5.06,1.49,12.37,2.67,21.4,2.33,18.05,5.86,43,9.66,70.47,1.9,13.76,3.64,26.88,5.12,38.82.39,3,.69,5.91,1.11,8.73s.85,5.56,1.26,8.2c.8,5.29,1.55,10.22,2.23,14.72,1.35,9,2.42,16.29,3.12,21.33.35,2.52.61,4.48.76,5.81.08.67.13,1.17.15,1.52a2.65,2.65,0,0,1,0,.38c0,.11-.06,0-.06,0a.1.1,0,0,0,0,0s.08,0,.07,0a1.4,1.4,0,0,0,0-.39c0-.34,0-.85-.1-1.52-.12-1.33-.35-3.3-.67-5.82-.65-5.05-1.66-12.35-3-21.36-.67-4.5-1.4-9.43-2.18-14.73-.4-2.64-.81-5.38-1.23-8.2s-.71-5.74-1.09-8.72c-1.46-11.95-3.19-25.07-5.08-38.84-3.8-27.51-7.39-52.4-9.81-70.45L492,243c-.32-2.51-.58-4.46-.75-5.81l-.21-1.51C491,235.29,491,235.11,491,235.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,430.76s0-.17-.07-.5-.14-.84-.24-1.47c-.22-1.3-.54-3.2-1-5.63l-3.63-20.69-12.14-68.22a15.61,15.61,0,0,1-.29-4.95c.2-1.63.48-3.29.72-4.91q.75-4.89,1.49-9.62c1-6.3,2-12.38,2.93-18.16,1.93-11.56,3.78-22,5.44-30.67s3.12-15.73,4.23-20.56c.52-2.43,1-4.29,1.29-5.57.15-.62.26-1.1.34-1.44s.09-.5.09-.5,0,.16-.14.49-.22.81-.38,1.43c-.33,1.27-.83,3.13-1.38,5.54-1.17,4.83-2.68,11.84-4.38,20.55s-3.6,19.09-5.54,30.66c-1,5.78-2,11.86-3,18.16q-.74,4.73-1.49,9.62c-.25,1.63-.52,3.25-.73,4.93a16.44,16.44,0,0,0,.3,5.09c4.79,26.62,9.13,50.72,12.28,68.19,1.59,8.71,2.88,15.77,3.78,20.66.45,2.43.8,4.32,1.05,5.62.12.62.21,1.11.28,1.46S470,430.76,470,430.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.31,264.13c-.14,0,1.49,11,3.63,24.47s4,24.42,4.11,24.4-1.5-11-3.64-24.47S480.44,264.11,480.31,264.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.53,434.64a3.05,3.05,0,0,0,.91.16c.58.07,1.43.15,2.47.23,2.1.17,5,.32,8.2.37s6.11,0,8.21-.1c1,0,1.89-.1,2.48-.15a3.91,3.91,0,0,0,.91-.12,26.91,26.91,0,0,0-3.4-.07c-2.1,0-5,0-8.19,0s-6.09-.15-8.19-.23A27.83,27.83,0,0,0,507.53,434.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,431.67a5.73,5.73,0,0,0,1.17-.06l3.16-.34c2.68-.3,6.36-.76,10.43-1.28s7.75-1,10.41-1.42l3.15-.48a6.7,6.7,0,0,0,1.15-.24,6.08,6.08,0,0,0-1.17,0c-.75.07-1.84.18-3.17.33-2.67.3-6.36.75-10.43,1.28s-7.75,1-10.41,1.43l-3.15.48A5.54,5.54,0,0,0,463,431.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.54,163.68,433,180.77s20.9-35.66,22.75-37.88,6.54-4.58,6.54-4.58L459.71,184s-11.31,28.86-26.83,27.29c-11.88-1.2-32.42-32.55-32.42-32.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M432.59,180.23a19.74,19.74,0,0,0-2.27,16.44,2.45,2.45,0,0,0,.91,1.45,1.79,1.79,0,0,0,2.25-.75,5.2,5.2,0,0,0,.58-2.53,5.76,5.76,0,0,0,1.66,2.17,2,2,0,0,0,2.53-.09c.74-.82.33-2.12-.12-3.14q-2.86-6.5-5.74-13"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M416.19,168.8c.14.09-2.16,3.95-5.15,8.62s-5.51,8.38-5.65,8.29,2.16-4,5.14-8.62S416.05,168.71,416.19,168.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.47,168.17c-.06,0,.23-.35.74-.15a1,1,0,0,1,.6.7,1,1,0,0,1-1.7.9,1,1,0,0,1-.24-.9c.13-.53.54-.6.55-.52s-.14.25-.12.57.28.66.69.45a.46.46,0,0,0,0-.82C410.76,168.2,410.51,168.25,410.47,168.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,191.6a12.4,12.4,0,0,1-1-5.39c-.05-3.07.71-5.47.86-5.42s-.31,2.43-.25,5.41S433.21,191.55,433,191.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.39,191.44c-.14.09-1.61-2.08-2.88-5.05a18.31,18.31,0,0,1-1.7-5.56c.17-.05,1,2.4,2.26,5.32S437.54,191.35,437.39,191.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.32,134l-3.4-6.72H481.35l-3.87,7.63-15.18,3.44-6.54,97.89a6.78,6.78,0,0,0,.87,3.55h0L516.32,242l2.43,1c2.14-1.32.81-6.78.83-9.34l.77-48.48,11.81-38.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M483.85,137.36l4.34-4.35q2.44,5.9,4.88,11.77a122.8,122.8,0,0,0,16-11.19l-16.53,5.31q-2.1-5.57-4.19-11.12a42.55,42.55,0,0,1-4.16,9.63"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M553.11,256.71l-16.09.83,0-46.17-16.64-26.15,11.81-38.74c2.43,1,20.76,47,25.43,59.48a14.08,14.08,0,0,1,.87,5.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.3,158.51c.17,0-.63,9.49-1.78,21.14s-2.22,21.11-2.39,21.09.63-9.48,1.79-21.15S462.14,158.5,462.3,158.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.32,127.81a59.72,59.72,0,0,1-2.93,7.87l-.33.79a1.89,1.89,0,0,1-.53.82,1,1,0,0,1-1.07.06,7.51,7.51,0,0,1-.68-.42l-2.21-1.5a9.81,9.81,0,0,1-1.95-1.51,10,10,0,0,1,2.18,1.15l2.28,1.38c.44.28.88.6,1.08.37a5,5,0,0,0,.67-1.37C486.6,131.16,488.16,127.75,488.32,127.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.86,133.81a27.23,27.23,0,0,1-3.75,1.51c-2.35.86-5.6,2-9.2,3.24l-2,.67-.27.09-.1-.26c-1.27-3.07-2.37-5.78-3.12-7.74a21,21,0,0,1-1.12-3.18,19.2,19.2,0,0,1,1.48,3c.86,1.91,2,4.6,3.31,7.66l-.37-.17,2-.68c3.61-1.23,6.88-2.31,9.26-3.07A25.08,25.08,0,0,1,507.86,133.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.63,147.86c0,.18-3.41,1.12-7.42,2.91s-7,3.72-7.14,3.57a7.81,7.81,0,0,1,1.88-1.43,38.4,38.4,0,0,1,10.36-4.61A8.05,8.05,0,0,1,529.63,147.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.32,127.81a1.11,1.11,0,0,1,0,.29c0,.23,0,.51,0,.86,0,.76.07,1.87.08,3.31,0,2.87,0,7-.19,12.16-.36,10.27-1.65,24.42-3.69,39.95-1,7.78-2.1,15.16-2.84,21.9a143,143,0,0,0-1,18,92.68,92.68,0,0,0,1,12.09c.18,1.43.41,2.52.52,3.26.05.35.09.63.12.86a1.06,1.06,0,0,1,0,.29,1.09,1.09,0,0,1-.09-.28c-.05-.23-.11-.5-.19-.84-.14-.74-.41-1.83-.62-3.25a82.56,82.56,0,0,1-1.15-12.12,136.33,136.33,0,0,1,.84-18c.71-6.76,1.8-14.15,2.79-21.91,2-15.53,3.4-29.65,3.87-39.9.26-5.12.34-9.27.38-12.14,0-1.4,0-2.5,0-3.31,0-.34,0-.63,0-.86A1.11,1.11,0,0,1,488.32,127.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554,249.64c0,.17-3.82.12-8.53-.11s-8.5-.55-8.49-.72,3.82-.12,8.52.11A61.24,61.24,0,0,1,554,249.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.71,251.44c0,.07,0,.23,0,.44s.26.34.47.17.14-.36-.06-.5-.36-.08-.42-.14.11-.33.54-.27a.75.75,0,0,1,.59.46.79.79,0,0,1-.27.92.8.8,0,0,1-1,.07.78.78,0,0,1-.33-.67C539.36,251.48,539.68,251.37,539.71,251.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M520.58,185.09l-5.24-9.47a130.21,130.21,0,0,0,3.46,49.94l1.62-40.26"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M494,167.69a5.32,5.32,0,0,1,1-.06l2.79-.07c2.43-.05,5.94-.11,10.16-.13h.28l0,.28c-.27,3.7-.58,8-.92,12.54v.17l-.15.08-.63.33-6.79,3.57-.17.09-.15-.12L493,179.21l-.1-.08V179c.3-3.39.54-6.22.72-8.31.09-.9.17-1.65.23-2.25a3.73,3.73,0,0,1,.11-.75,5.78,5.78,0,0,1,0,.86c0,.61-.06,1.38-.1,2.31-.11,2-.27,4.84-.46,8.17l-.09-.21,6.37,5.09-.32,0,6.78-3.59.62-.33-.16.24c.37-4.56.71-8.83,1-12.53l.27.29c-4.11,0-7.55-.08-10-.13l-2.86-.07A9,9,0,0,1,494,167.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.45,240.24c0,.16-1.26-.06-2.07-1.27s-.56-2.45-.4-2.39.21,1,.91,2S464.5,240.07,464.45,240.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,239.59a5.53,5.53,0,0,1-1.52-6c.18,0,0,1.44.43,3.09S466.14,239.48,466,239.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.06,232.86c.15,0,.29,2.35-.94,4.93s-3.12,4-3.2,3.86,1.52-1.67,2.65-4.12S510.87,232.84,511.06,232.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.28,165.55s-18.18-13.77-20.72-14.69c-4.23-1.53-5.25-1.12-5.25-1.12l10,10.74s-10.54,3.55-11.3,4-1.13,2.74,1.43,2.74c2.11,0,12.22.24,12.22.24l8.33,6.08Z",
    style: {
      fill: "#ffbe9d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.14,46.91a2.47,2.47,0,0,1,.6,0l1.76.05c.39,0,.82,0,1.3,0l1.55.22,1.82.26,2,.51A32.84,32.84,0,0,1,589,52.27,34.64,34.64,0,0,1,605,78.34a35.66,35.66,0,0,1,.1,4.75c-.06.8,0,1.62-.16,2.43s-.25,1.62-.37,2.45a34.77,34.77,0,0,1-3.3,9.66,37.37,37.37,0,0,1-6.32,8.7,36.54,36.54,0,0,1-9.1,6.53,33.09,33.09,0,0,1-11.09,3.41,22.3,22.3,0,0,1-3,.25,27.08,27.08,0,0,1-3,0,35.94,35.94,0,0,1-6-.75,35,35,0,0,1-11.92-5l.36,0-12.15,4.88-.72.29.21-.75c1.22-4.46,2.42-8.79,3.57-13l.06.32a34.87,34.87,0,0,1-6.48-14.84,31.66,31.66,0,0,1-.47-7.6,24.53,24.53,0,0,1,.34-3.66c.09-.59.19-1.18.28-1.77s.28-1.15.42-1.72a34.78,34.78,0,0,1,13.55-19.76A33.45,33.45,0,0,1,557.89,49c.63-.23,1.23-.45,1.82-.65l1.72-.44,1.58-.39c.5-.1,1-.15,1.45-.22.92-.12,1.73-.28,2.43-.31l1.79-.06,1.09,0a1.53,1.53,0,0,1,.37,0,2.89,2.89,0,0,1-.37.05l-1.09.08-1.77.12c-.7.06-1.5.23-2.41.37a34.53,34.53,0,0,0-27.62,25.62c-.13.56-.31,1.12-.41,1.69s-.17,1.16-.26,1.75a22.16,22.16,0,0,0-.32,3.58,30.9,30.9,0,0,0,.49,7.45,34.22,34.22,0,0,0,6.39,14.52l.11.15,0,.17c-1.14,4.2-2.32,8.54-3.54,13l-.51-.45,12.14-4.89.19-.08.17.11a34.2,34.2,0,0,0,11.66,4.91,35.33,35.33,0,0,0,5.85.74,26,26,0,0,0,2.93-.06,19.88,19.88,0,0,0,2.89-.24,32.17,32.17,0,0,0,10.85-3.32,35.78,35.78,0,0,0,8.91-6.38,36.59,36.59,0,0,0,6.2-8.49,34.09,34.09,0,0,0,3.27-9.46c.12-.81.25-1.61.37-2.4s.1-1.59.16-2.38a34.54,34.54,0,0,0-.07-4.67,34.34,34.34,0,0,0-15.52-25.75,32.92,32.92,0,0,0-9.66-4.36l-2-.53-1.79-.3-1.54-.25c-.47-.05-.91-.06-1.29-.1L570.73,47A5.51,5.51,0,0,1,570.14,46.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.55,90a2.31,2.31,0,0,1-.41,0l-1.18,0-4.38.07-14.67.13h-.12v-.12c-.12-.77-.24-1.6-.36-2.43-1-7.11-1.92-13.46-2.51-17.6l.08.07-3.9,0h-1l-.36,0a1.65,1.65,0,0,1,.36,0l1,0L558,70h.08v.07c.62,4.15,1.56,10.49,2.62,17.59l.35,2.43-.14-.12,14.67,0L580,90l1.19,0A1.93,1.93,0,0,1,581.55,90Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.22,90.4l0,0h-.49l-.08-.5,0,0h0l0-.12-.29-2L557.81,70.3l-4.76,0c-.42,0-.49,0-.49-.14v-.05l0,0s0,0,.45-.07l1,0,3.67-.05v-.1l.1.09h.34l0,.18a.88.88,0,0,0,0,.16l.1.09h-.09c.62,4.15,1.54,10.38,2.58,17.34l.32,2.21,14.44,0,5.56,0c.47,0,.53,0,.53.15s0,.14-.53.15l-1.18,0-4.37.06-14.37.13Zm0-.3v0l3.9,0ZM559.88,83l1,6.84h0l-.32-2.17C560.33,86.08,560.1,84.52,559.88,83Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.29,85.84h.41l1.18,0,4.41-.07,15.23-.14-.13.11c.44-2.56.91-5.34,1.4-8.21.25-1.47.5-2.92.73-4.31l.14.16-17.95.06H559l-.37,0h0l.37,0,1.43,0,5.31-.07,17.95-.15h.16l0,.16c-.23,1.38-.48,2.83-.73,4.31-.49,2.87-1,5.64-1.41,8.21l0,.11h-.11l-15.23,0h-4.41l-1.18,0h-.41Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.29,86l-5.9,0c-.11,0-.23,0-.23-.14s.12-.13.23-.14l1.48,0,4.42-.06,15-.14,1.36-8c.24-1.37.47-2.71.69-4l-17.64.06-7.12,0c-.13,0-.25,0-.25-.14s.12-.13.25-.14l1.8,0,5.32-.08,17.73-.15v0l0,0H584l-.08.48,0,0h0l-2,12h0l0,0-.08.48h-.49l0,0v0Zm15-.3-2.22,0Zm2.34-12.25c-.22,1.3-.45,2.66-.69,4l-1.35,8h0l2-12Zm-.21-.27-4.39,0h4.39Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.1,95.68s0-.18-.12-.49a2,2,0,0,0-.76-1.07,2,2,0,0,0-1.85-.24,1.94,1.94,0,0,0-1.25,1.82,2,2,0,0,0,1.27,1.82,2,2,0,0,0,1.85-.27,2.09,2.09,0,0,0,.75-1.08c.09-.3.09-.49.11-.49a1,1,0,0,1,0,.52,2.06,2.06,0,0,1-.73,1.2,2.18,2.18,0,1,1-2.08-3.76,2.13,2.13,0,0,1,2.06.33,2.11,2.11,0,0,1,.75,1.19C566.15,95.5,566.12,95.68,566.1,95.68Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564,98a2.18,2.18,0,0,1-.74-.13,2.3,2.3,0,0,1-1.56-2.16,2.3,2.3,0,0,1,3.71-1.84,2.15,2.15,0,0,1,.79,1.27,1.44,1.44,0,0,1,0,.54,1.63,1.63,0,0,1,0,.54,2.17,2.17,0,0,1-.78,1.28A2.31,2.31,0,0,1,564,98Zm-.43-4.32-.26.08a2.06,2.06,0,0,0,0,3.88l.26.07-.25-.08a2.06,2.06,0,0,1,0-3.87Zm.48.2a1.73,1.73,0,0,0-.65.12,1.82,1.82,0,0,0-1.17,1.7,1.83,1.83,0,0,0,2.92,1.45,2,2,0,0,0,.71-1,2.09,2.09,0,0,0,.08-.37s0-.06,0-.09a.19.19,0,0,1,0-.08,2.12,2.12,0,0,0-.09-.37,1.91,1.91,0,0,0-.71-1A1.84,1.84,0,0,0,564.06,93.88Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.38,95.6s0-.18-.12-.49a2,2,0,0,0-.76-1.06,2,2,0,0,0-3.11,1.58,2,2,0,0,0,1.28,1.81,2,2,0,0,0,1.85-.27,2.07,2.07,0,0,0,.75-1.07c.09-.31.09-.5.11-.5a1.11,1.11,0,0,1,0,.52,2,2,0,0,1-.73,1.21,2.18,2.18,0,1,1,0-3.44,2.1,2.1,0,0,1,.75,1.2A1,1,0,0,1,579.38,95.6Z",
    style: {
      fill: "#D63C6D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.29,97.92a2.26,2.26,0,0,1-.75-.12,2.31,2.31,0,1,1,2.16-4,2.21,2.21,0,0,1,.79,1.27,1.44,1.44,0,0,1,0,.54,1.63,1.63,0,0,1,0,.54,2.24,2.24,0,0,1-2.21,1.78Zm-.45-4.31-.24.07a2.06,2.06,0,0,0,0,3.88l.29.08-.28-.08a2.07,2.07,0,0,1,0-3.88Zm.5.19a1.69,1.69,0,0,0-.65.12,1.82,1.82,0,1,0,1.75,3.15,2,2,0,0,0,.71-1,3.74,3.74,0,0,0,.08-.37.29.29,0,0,1,0-.09.19.19,0,0,1,0-.08c0-.08,0-.21-.09-.37a1.91,1.91,0,0,0-.71-1A1.86,1.86,0,0,0,577.34,93.8Z",
    style: {
      fill: "#D63C6D"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.2b48834749509cef88ad5a39e8707ece.svg";
export { ForwardRef as ReactComponent };